<template>
    <v-navigation-drawer v-model="$store.state.Notification_drawer" absolute right color="grey lighten-4 pt-12" clipped :width="!$store.state.Notification_drawer ? '0px' : ''" style="position: fixed; top: 0; overflow: auto; width: 250px;">
        <v-list>
            <v-list-item v-for="item in $store.state.Notifications" :key="item.id" class="mx-0 px-2">
                <v-card style="width: 100%;" class="my-1">
                    <v-card-text class="pa-1">
                        <div class="d-flex justify-space-between align-center">
                            <small class="font-weight-regular" style="font-size: 10px;">
                                {{ item.sender_username }}, {{ $localeDateTime(item.datetime) }}
                            </small>

                            <!-- <v-icon small v-tooltip="'mark as read'">mdi-email-open-outline</v-icon> -->
                            <v-badge v-if="!item.read_status" color="red lighten-1" dot class="mr-2"></v-badge>
                        </div>
                        <div class="h5 font-weight-bold">{{ item.title }}</div>
                        <div style="line-height: 100%; font-size: 13px;">
                            <span class="grey--text text--darken-2" v-html="item.description"></span>
                        </div>
                    </v-card-text>
                </v-card>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import axios from '../plugins/axios'

export default {
    data: () => ({
        // items: [],
        loading: false,
        queryParams: {},
    }),
    methods: {
        getItems() {
            this.loading = true
            axios.get(`/api/notifications/index`, {params: this.queryParams}).then((resp) => {
                // this.items = resp.data
                this.$store.state.Notifications = resp.data
            }).finally(() => this.loading = false)
        }
    },
    mounted() {
        this.getItems()

        if (window.Echo) {
            window.Echo.private(`notifications.${this.User.staff.ISMID}`)
                .listen('NewNotificationSent', (e) => {
                    // this.items = e.notifications
                    this.$store.state.Notifications = e.notifications
                });
        }
    },
    watch: {
        "$store.state.Notification_drawer"() {
            if (this.$store.state.Notification_drawer) {
                this.queryParams.read = true
                this.getItems()
                this.queryParams = {}
            }

            if (!this.$store.state.Notification_drawer) {
                this.queryParams = {}
                this.getItems()
            }
        }
    },
}
</script>

<style>

</style>